export default class AddQuestionnaireToWorkspaceController {
  constructor ($scope, questionnaires, workspaceInteractor, workspaceId, close) {
    this.$scope = $scope;
    this.questionnaires = questionnaires.map(q => {return {label: q.name, id: q.id}});
    this.workspaceInteractor = workspaceInteractor;
    this.workspaceId = workspaceId;
    this.close = close;
  }

  addQuestionnaire (questionnaire) {
    return this.workspaceInteractor.addQuestionnaire(this.workspaceId, questionnaire.id)
      .then(() => this.close());
  }

  questionnaireSelected(questionnaire) {
    this.selectedQuestionnaire = questionnaire;
  }
}